<nav class="navbar navbar-expand-lg navbar-light p-0" aria-label="breadcrumb">
    <div class="container-fluid p-0 d-flex mt-0 w-img" style="height: 200px; background-color: #092f56;">
        <div class="container">
            <ol class="breadcrumb">
                <li class="breadcrumb-item breadcrumb-item-color"><a href="#">Home</a></li>
                <li class="breadcrumb-item breadcrumb-item-menu">{{ menu }}</li>
                <li class="breadcrumb-item active" aria-current="page" >{{ menuItem }}</li>
            </ol>
        </div>
    </div>
</nav>